import { PATHS } from './paths';
import AlertTriangle from '@geist-ui/icons/alertTriangle';
import ArrowUpCircle from '@geist-ui/icons/arrowUpCircle';
import {Mail,Octagon, Plus, Settings, Tag, User, UserPlus, Users , Map, Tool, Trello, Bell, DollarSign, Home} from '@geist-ui/icons/';
import Briefcase from '@geist-ui/icons/briefcase'
import { apiInstance } from 'src/services';

export const dashboardRoutes = [
  {
    title: 'dashboardRoutes.sitemap',
    path: '/account/account-details/sitemap', 
    key: 'sitemap',
  },
  // {
  //   title: 'dashboardRoutes.accessibilityDashboard',
  //   path: PATHS.ACCESSIBILITY_DASHBOARD,
  //   key: 'accessibilityDashBoard',
  // },
  // {
  //   title: 'dashboardRoutes.automatedAudit',
  //   path: PATHS.AUTOMATED_AUDIT,
  //   key: 'automatedAudit',
  // },
  {
    title: 'dashboardRoutes.settings',
    path: '/account/account-details/settings',
    key: 'settings',
  },
  // { title: 'dashboardRoutes.manualAudit', path: PATHS.MANUAL_AUDIT, key: 'manualAudit' },
  // { title: 'dashboardRoutes.widget', path: PATHS.WIDGET, key: 'widget' },
  // { title: 'dashboardRoutes.reported', path: PATHS.REPORTED, key: 'reported' },
];

export const footerRoutes = [
  { title: 'footerRoutes.myWebsites', path: PATHS.DASHBOARD, blank: false },
  // { title: 'footerRoutes.myPlan', path: PATHS.PLAN, key: 'plan' },
  { title: 'footerRoutes.account', path: PATHS.ACCOUNT, blank: false },
  {
    title: 'footerRoutes.modernSlavery',
    path: 'https://vially.io/services/modern-slavery-policy',
    blank: true,
  },
  { title: 'footerRoutes.FAQ', path: PATHS.FAQ, blank: false, ariaLabel : 'frequently asked Question' },
  {
    title: 'footerRoutes.privacyStatement',
    path: 'https://vially.io/privacy-policy',
    blank: true,
  },
  {
    title: 'footerRoutes.termsOfService',
    path: 'https://vially.io/services/terms-of-service',
    blank: true,
  },
  {
    title: 'footerRoutes.accessibilityStatement',
    path: 'https://vially.io/accessibility-statement',
    blank: true,
  },
];

interface headerRoutesProps {
  title: string;
  path: string;
  visible: boolean;
  isSuperAdmin?: boolean;
  field?: string;
  icon?: any; // This allows you to assign a React component
  func?:()=>void
  children?:any
  label?: string
}
const navigateToPayment = (): void => {
  apiInstance.get('payment/portal').then((res) => {
    window.open(res.data.url, '_blank');
  });
};

const navigatToSelectedSiteIssues = () => {
  // const savedSite = localStorage.getItem('selectedSite');
  //   if (savedSite) {
  //     const data = JSON.parse(savedSite);
  //     const query =  `${PATHS.DASHBOARD}/${data?.site_id}/automated-audit?siteUUID=${data?.id}&pageNumber=1`
  //     return query
  //   }
    const query =  `dashboard/automated-audit/select`
    return query
 
}
const navigateToSitemap = () => {
  const savedSite = localStorage.getItem('selectedSite');
    if (savedSite) {
      const data = JSON.parse(savedSite);
      const query =  `${PATHS.DASHBOARD}/${data?.site_id}/sitemap?siteUUID=${data?.id}&pageNumber=1`
      return query
    }
    const query =  `dashboard/automated-audit/select`
    return query
}
export const headerRoutes: headerRoutesProps[] = [
  { title: 'headerRoutes.dashboard', path: PATHS.DASHBOARD, visible: true, field: '', icon: Home  },
  { title: 'headerRoutes.issues', path: PATHS.AUTOMATED_AUDIT_SELECT, visible: true, field: '', icon: AlertTriangle , label: 'Issues page' , 
    // children : [
    //   {
    //     title: 'headerRoutes.criteria', 
    //     path:  '?page=Criteria',
    //     visible: true, 
    //     field: '', 
    //     icon: AlertTriangle
    //   },
    //   {
    //     title: 'headerRoutes.page', 
    //     path:  '?page=Issues By',
    //     visible: true, 
    //     field: '', 
    //     icon: Display
    //   },
    //   {
    //     title: 'headerRoutes.open', 
    //     path:  '?page=Open Issue',
    //     visible: true, 
    //     field: '', 
    //     icon: Triangle
    //   },
    //   {
    //     title: 'headerRoutes.close', 
    //     path:  '?page=Close Issue',
    //     visible: true, 
    //     field: '', 
    //     icon: TrendingUp
    //   },
    // ]


  },
  // { title: 'headerRoutes.audits', path: PATHS.USERS, visible: true, isSuperAdmin: true, icon: Archive  },
  { title: 'headerRoutes.upgrade', path: '#', visible: true, isSuperAdmin: true, icon: ArrowUpCircle, func:navigateToPayment  , label: 'Upgrade your current plan, link opens in new tab'},
  { title: 'headerRoutes.settings', path: '#', visible: true, field: '', icon: Settings , label: 'setting tab',
      children:[
        {
          title: 'headerRoutes.accountDetails', 
          path: '/account/account-details', 
          visible: true, 
          field: '', 
          icon: User
        },
        // {
        //   title: 'headerRoutes.password', 
        //   path: PATHS.PASSWORD, 
        //   visible: true, 
        //   field: '', 
        //   icon: Settings
        // },
        // {
        //   title: 'headerRoutes.notifications', 
        //   path: PATHS.NOTIFICATION, 
        //   visible: true, 
        //   field: '', 
        //   icon: Mail
        // },
        {
          title: 'Companies', 
          path: PATHS.ORGANIZATION, 
          visible: true, 
          field: '', 
          icon: Briefcase
        },
        {
          title: 'Invitations', 
          path:  PATHS.COMPANY, 
          visible: true, 
          field: '', 
          icon: Bell
        },
         {
          title: 'Billing', 
          path:  PATHS.BILLINGPAGE, 
          visible: true, 
          field: '', 
          icon: DollarSign
        },
        // {
        //   title: 'headerRoutes.clients', 
        //   path: PATHS.CLIENT, 
        //   visible: true, 
        //   field: '', 
        //   icon: Plus
        // },
        // {
        //   title: 'headerRoutes.permissions', 
        //   path: PATHS.PERMISSIOM, 
        //   visible: true, 
        //   field: '', 
        //   icon: UserPlus
        // },

        // {
        //   title: 'headerRoutes.manageUsers', 
        //   path: PATHS.MANAGEUSERS, 
        //   visible: true, 
        //   field: '', 
        //   icon: Users
        // },
        // {
        //   title: 'headerRoutes.manageWesistes', 
        //   path: PATHS.MANAGEWEBSITES, 
        //   visible: true, 
        //   field: '', 
        //   icon: Octagon
        // },
        // {
        //   title: 'headerRoutes.manageTags', 
        //   path: PATHS.MANAGETAGS, 
        //   visible: true, 
        //   field: '', 
        //   icon: Tag
        // },
        // {
        //   title: 'headerRoutes.sitemap', 
        //   path: navigateToSitemap(), 
        //   visible: true, 
        //   field: '', 
        //   icon: Map
        // }
      ]
       },
  { title: 'Support', path: PATHS.SUPPORT, visible: true, field: '', icon: Mail ,  label: 'Support Page' },
  // { title: 'headerRoutes.companies', path: PATHS.COMPANY, visible: true, field: '', icon: Briefcase },
  // { title: 'headerRoutes.contactSales', path: PATHS.SUPPORT, visible: true, field: '', icon: Mail },
  { title: 'headerRoutes.companies', path: PATHS.COMPANY, visible: true, field: '', icon: Briefcase },
  
  { title: 'Tools', path: PATHS.TOOLS, visible: true, field: '', icon: Tool, 
    children:[
      {
        title: 'Color Contrast Checker', 
        path: PATHS.TOOLS, 
        visible: true, 
        field: '', 
        icon: Trello
      },
      {
        title: 'Image Description Checker', 
        path: PATHS.IMAGEDESCRIPTIONCHECKER, 
        visible: true, 
        field: '', 
        icon: Trello
      },
      // {
      //   title: 'Image Color Checker', 
      //   path: PATHS.IMAGECOLORCONSTRACTCHECkER, 
      //   visible: true, 
      //   field: '', 
      //   icon: Trello
      // },
      {
        title: 'Single Page Checker', 
        path: PATHS.SINGLEPAGECHECKER, 
        visible: true, 
        field: '', 
        icon: Trello
      },
      {
        title: 'Check Code Snippet', 
        path: PATHS.CODEACCESSIBILITY, 
        visible: true, 
        field: '', 
        icon: Trello
      },
      {
        title: 'Language Level Checker', 
        path: PATHS.LANGUAGELEVELCHECKER, 
        visible: true, 
        field: '', 
        icon: Trello
      },
      
    ]
  },
  // { title: 'headerRoutes.settings', path: PATHS.ACCOUNT, visible: true, field: '', icon: Settings , 
  // children:[
  //   {
  //     title: 'headerRoutes.accountDetails', 
  //     path: PATHS.ACCOUNT, 
  //     visible: true, 
  //     field: '', 
  //     icon: User
  //   },
  //   // {
  //   //   title: 'headerRoutes.password', 
  //   //   path: PATHS.PASSWORD, 
  //   //   visible: true, 
  //   //   field: '', 
  //   //   icon: Settings
  //   // },
  //   // {
  //   //   title: 'headerRoutes.notifications', 
  //   //   path: PATHS.NOTIFICATION, 
  //   //   visible: true, 
  //   //   field: '', 
  //   //   icon: Mail
  //   // },
  //   {
  //     title: 'headerRoutes.organizations', 
  //     path: PATHS.ORGANIZATION, 
  //     visible: true, 
  //     field: '', 
  //     icon: Briefcase
  //   },
  //   // {
  //   //   title: 'headerRoutes.clients', 
  //   //   path: PATHS.CLIENT, 
  //   //   visible: true, 
  //   //   field: '', 
  //   //   icon: Plus
  //   // },
  //   // {
  //   //   title: 'headerRoutes.permissions', 
  //   //   path: PATHS.PERMISSIOM, 
  //   //   visible: true, 
  //   //   field: '', 
  //   //   icon: UserPlus
  //   // },

  //   // {
  //   //   title: 'headerRoutes.manageUsers', 
  //   //   path: PATHS.MANAGEUSERS, 
  //   //   visible: true, 
  //   //   field: '', 
  //   //   icon: Users
  //   // },
  //   // {
  //   //   title: 'headerRoutes.manageWesistes', 
  //   //   path: PATHS.MANAGEWEBSITES, 
  //   //   visible: true, 
  //   //   field: '', 
  //   //   icon: Octagon
  //   // },
  //   // {
  //   //   title: 'headerRoutes.manageTags', 
  //   //   path: PATHS.MANAGETAGS, 
  //   //   visible: true, 
  //   //   field: '', 
  //   //   icon: Tag
  //   // },
  //   // {
  //   //   title: 'headerRoutes.sitemap', 
  //   //   path: navigateToSitemap(), 
  //   //   visible: true, 
  //   //   field: '', 
  //   //   icon: Map
  //   // }
  // ]
  //  },
  // { title: 'headerRoutes.upgrade', path: '', visible: true, isSuperAdmin: true, icon: ArrowUpCircle, func:navigateToPayment },
  // { title: 'headerRoutes.contactSales', path: PATHS.SUPPORT, visible: true, field: '', icon: Mail },
  // { title: 'headerRoutes.companies', path: PATHS.COMPANY, visible: true, field: '', icon: Briefcase },
   
  // { title: 'headerRoutes.sitemap', path: navigateToSitemap(), visible: true, field: '', icon: Map }
];
